import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Card,
  Badge,
  Accordion,
  Button,
  ListGroup,
  ProgressBar,
} from "react-bootstrap";
import defaultcover from "assets/covers/defaultcover.svg";
import { capitalize } from "tools/capitalize";
import CustomToggle from "../CustomToggle/CustomToggle";
import "./ApprenticePathCard.scss";

const ApprenticePathCard = ({ learningPath, subscribed, imgHeight }) => {
  const { title, description, courses, slug } = learningPath;
  const currentUser = useSelector((state) => state.auth.currentUser);
  const { t } = useTranslation();

  const getProgress = (course) => {
    return course.progression;
  };

  const imageURL = learningPath.large_image_url || learningPath.image_url || defaultcover;

  return (
    <Accordion
      className="ApprenticePathCard rounded overflow-hidden mb-4 p-0 mx-2 col-lg-5"
      data-aos="fade-up"
    >
      <Card>
        <Card.Img
          variant="top"
          src={imageURL || defaultcover}
          alt="Cover"
          style={{ height: imgHeight || "180px", objectFit: "cover" }}
        />

        <Card.Body className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <Card.Title className="h5 mb-0">{title}</Card.Title>
            <CustomToggle eventKey="0" className="btn btn-sm btn-outline-secondary">
              💡
            </CustomToggle>
          </div>

          <Accordion.Collapse eventKey="0">
            <div className="mb-3">
              {description ? (  
                <small className="text-muted">{description}</small>
              ) : (
                <small className="text-muted">{t("common:no_description")}</small>
              )}
            </div>
          </Accordion.Collapse>

          <CustomToggle
            as={Button}
            eventKey="1"
            className="btn btn-outline-primary btn-block btn-sm courses-button"
          >
            📚 {capitalize(t("company:course"))}
          </CustomToggle>

          <Accordion.Collapse eventKey="1">
            <div>
              <ListGroup variant="flush">
                {courses.map((course) => {
                  const progression = getProgress(course);
                  const statusEmoji = progression === 100 ? "✔️" : "⌛";

                  return (
                    <ListGroup.Item key={course.id}>
                      <div className="d-flex justify-content-between align-items-center mb-1">
                        <a
                          href={`/chapters?courseId=${course.id}`}
                          className="font-weight-bold text-secondary course-title"
                          style={{ textDecoration: "none" }}
                        >
                          {statusEmoji} {course.title}
                        </a>
                      </div>

                      
                        <>
                          <ProgressBar
                            now={progression}
                            variant={progression === 100 ? "success" : "warning"}
                            className="mb-1"
                          />
                          <small className="text-muted">
                            {t("profile:progression")}: {progression}%
                          </small>
                        </>
                      
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            </div>
          </Accordion.Collapse>
        </Card.Body>
      </Card>
    </Accordion>
  );
};

export default ApprenticePathCard;
